<script setup lang="ts">
const emit = defineEmits<{
  submit: []
}>()

withDefaults(defineProps<{
  isCrossedSearch?: boolean
}>(), {
  isCrossedSearch: false,
})

const formPassengers = defineModel<SearchFormPassengers>({ required: true })
const showAdvancedPassengers = defineModel<boolean>('showAdvancePassengers')

const { t } = useI18n()
const formatTravelersCount = (count: number | null) => {
  if (count === null) return 0
  if (count === 6) {
    return t('components.app_search.filters.6_more')
  }
  return count
}

const onSubmit = () => {
  if (formPassengers.value.seatbelts === 0) {
    formPassengers.value.seatbelts = null
  }
  if (formPassengers.value.beds === 0) {
    formPassengers.value.beds = null
  }
  emit('submit')
}
</script>

<template>
  <form
    id="search-form-passengers"
    class="flex flex-col max-h-[calc(100vh-15rem)] overflow-y-auto w-96"
    @submit.prevent="onSubmit"
  >
    <AppSearchFilterFormSection
      :title="$t('commons.travelers')"
    >
      <div class="flex justify-between w-full items-center">
        <label>{{ showAdvancedPassengers ? $t('components.app_search.filters.seats') : $t('components.app_search.filters.travelers') }}</label>
        <YscInputNumber
          id="seatsbelts"
          v-model="formPassengers.seatbelts"
          class="text-lg"
          :min="0"
          :max="6"
        >
          {{ formatTravelersCount(formPassengers.seatbelts) }}
        </YscInputNumber>
      </div>
      <div
        v-if="showAdvancedPassengers"
        class="flex justify-between w-full items-center"
      >
        <label>{{ $t('components.app_search.filters.beds') }}</label>
        <YscInputNumber
          id="beds"
          v-model="formPassengers.beds"
          class="text-lg"
          :min="0"
          :max="6"
        >
          {{ formatTravelersCount(formPassengers.beds) }}
        </YscInputNumber>
      </div>
      <button
        class="link link-primary text-sm"
        role="button"
        type="button"
        @click="showAdvancedPassengers = !showAdvancedPassengers"
      >
        {{ showAdvancedPassengers ? $t('components.app_search.display_less_criterias') : $t('components.app_search.display_all_criterias') }}
      </button>
    </AppSearchFilterFormSection>
    <AppSearchFilterFormSection :title="$t('components.app_search.filters.preferences')">
      <YscInputCheckbox
        id="pets"
        v-model="formPassengers.pets"
        name="pets"
        class="flex-row-reverse justify-between !space-x-0 w-full"
        is-block
      >
        {{ $t('components.app_search.filters.pets') }}
      </YscInputCheckbox>
      <YscInputCheckbox
        v-if="!isCrossedSearch"
        id="disabled-access"
        v-model="formPassengers.disabled_access"
        name="disabled_access"
        class="flex-row-reverse justify-between !space-x-0 w-full"
        is-block
      >
        {{ $t('components.app_search.filters.disabled_access') }}
      </YscInputCheckbox>
    </AppSearchFilterFormSection>
  </form>
</template>
